import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Button from "@mui/material/Button";
import { Facebook, Email } from '@mui/icons-material/';
import PayPalLogo from "../../img/paypal-seeklogo.com.svg";
import BustLogo from "../../img/bust-logo.png";

const useStyles = makeStyles(theme => ({
    footer: {
        backgroundColor: theme.footer.background,
        width:'100%',
        height: '100%',
        borderTop: '2px solid #0A2466',
        "& p": {
            margin: '0px',
        }
    },
    btn: {
        alignSelf: 'flex-start',
        display: 'flex',
        position: 'absolute',
        right: '0',
        top: '20px',
        height: '35px',
        marginTop: '6px',
        marginLeft: '4px',
        '& > a': {
            fontSize: '48px',
            marginLeft: 'auto',
        },
    },
    footerContainer: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '20px 0',
    },
    footerLinks: {
        '& a': {
            color: '#0A2466',
        },
        '& ul': {
            '& li': {
                textDecoration: 'none',
            }
        }
    },
    payPalbtn: {
        '& a': {
          height: '70px',
          width: '240px',
          fontSize: '2.1em',
          fontWeight: '600',
          marginTop: '3px'
        },
        '& img': {
            marginRight: '10px',
            width: '40px',
            height: 'auto',
        }
    },
    payPalbtnContainer: {
        display: 'flex',
        width: '200px',
        '& a': {
            marginRight: '40px',
            fontSize: '46px',
            display: 'flex',
            '&:hover svg': {
                color: '#0966d2',
            }
        },
        '& path': {
          // filter: 'drop-shadow(1px 1px 1px rgba(0,0,0,.5))',
        },
    },
    disclosure: {
        borderTop: '1px solid #0A2466',
        textAlign: 'center',
        '& > div': {
            paddingTop: '50px',
            paddingBottom: '100px',
        }
    }
}));

const Footer = () => {
    const classes = useStyles();

    return (
        <div className={classes.footer}>
            <Container>
                <div className={classes.footerContainer}>
                    <div className={classes.footerLogo}>
                        <img src={BustLogo} alt="Stedman for Senate, Bert Stedman Bust, Logo"/>
                    </div>
                    {/*<div className={classes.footerLinks}>*/}
                    {/*    <ul>*/}
                    {/*        <li><Link to='/'>Home</Link></li>*/}
                    {/*        <li><Link to='/articles'>Articles</Link></li>*/}
                    {/*        <li><Link to='/leadership'>Leadership</Link></li>*/}
                    {/*        <li><Link to='/contact'>Contact</Link></li>*/}
                    {/*    </ul>*/}
                    {/*</div>*/}
                    <div className={classes.btn}>
                        {/* <a className={classes.fbBtn} href='mailto:bert@stedmanforsenate.com?subject=Campaign Contact' target='_blank' rel="noopener noreferrer">
                            <Email color='primary' fontSize='inherit' />
                        </a>
                        <a className={classes.fbBtn} href="https://www.facebook.com/stedmanforsenate/" target='_blank' rel="noopener noreferrer">
                            <Facebook color='primary' fontSize='inherit'/>
                        </a> */}
                        <div className={classes.payPalbtn}>
                            <Button variant='contained' href='https://www.paypal.com/ncp/payment/3GWWYDMCP6NXE' target='_blank'>
                                <img src={PayPalLogo} alt="Stedman for Senate PayPal Donate button"/>
                                Donate
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>
            <div className={classes.disclosure}>
                <div>
                    <p>Paid for by Stedman for Senate</p>
                    <p>118 American Street, Sitka, Alaska, 99835</p>
                </div>
            </div>
        </div>
    )
}

export default Footer;
